import PasswordCreate from 'pages/Accounts/AuthenticationInner/PasswordCreate';
import React from 'react';

const ResetPassword = (): JSX.Element => {
  return <PasswordCreate />;
};

export default ResetPassword;
